import {ILeadModalConsultant} from "../../types/lead/ILeadModalConsultant";

const wiktoria_72 = require("../../images/consultants/wiktoria_mosciszko_72x27.png");
const wiktoria_144 = require("../../images/consultants/wiktoria_mosciszko_144x144.png");
const wiktoria_216 = require("../../images/consultants/wiktoria_mosciszko_216x216.png");
const roza_72 = require("../../images/consultants/roza_parzyszek_72x27.png");
const roza_144 = require("../../images/consultants/roza_parzyszek_144x144.png");
const roza_216 = require("../../images/consultants/roza_parzyszek_216x216.png");
const justyna_72 = require("../../images/consultants/justyna_budrewicz_72x27.png");
const justyna_144 = require("../../images/consultants/justyna_budrewicz_144x144.png");
const justyna_216 = require("../../images/consultants/justyna_budrewicz_216x216.png");
const daniel_72 = require("../../images/consultants/daniel_reinert_72x27.png");
const daniel_144 = require("../../images/consultants/daniel_reinert_144x144.png");
const daniel_216 = require("../../images/consultants/daniel_reinert_216x216.png");

const consultantList: ILeadModalConsultant[] = [
    {
        image: {s72: wiktoria_72, s144: wiktoria_144, s216: wiktoria_216},
        gender: "female",
        fullName: "Wiktoria Mościszko"
    },
    {
        image: {s72: roza_72, s144: roza_144, s216: roza_216},
        gender: "female",
        fullName: "Róża Parzyszek"
    },
    {
        image: {s72: justyna_72, s144: justyna_144, s216: justyna_216},
        gender: "female",
        fullName: "Justyna Budrewicz"
    },
    {
        image: {s72: daniel_72, s144: daniel_144, s216: daniel_216},
        gender: "male",
        fullName: "Daniel Reinert"
    }
];

export function getRandomConsultant() {
    const randomIndex = Math.floor(Math.random() * consultantList.length);
    return consultantList[randomIndex];
}
import {ILeadModalConsultant} from "../../types/lead/ILeadModalConsultant";

const wiktoria_72 = require("../../images/consultants/wiktoria_mosciszko_72x27.png");
const wiktoria_144 = require("../../images/consultants/wiktoria_mosciszko_144x144.png");
const wiktoria_216 = require("../../images/consultants/wiktoria_mosciszko_216x216.png");
const roza_72 = require("../../images/consultants/roza_parzyszek_72x27.png");
const roza_144 = require("../../images/consultants/roza_parzyszek_144x144.png");
const roza_216 = require("../../images/consultants/roza_parzyszek_216x216.png");
const justyna_72 = require("../../images/consultants/justyna_budrewicz_72x27.png");
const justyna_144 = require("../../images/consultants/justyna_budrewicz_144x144.png");
const justyna_216 = require("../../images/consultants/justyna_budrewicz_216x216.png");
const daniel_72 = require("../../images/consultants/daniel_reinert_72x27.png");
const daniel_144 = require("../../images/consultants/daniel_reinert_144x144.png");
const daniel_216 = require("../../images/consultants/daniel_reinert_216x216.png");

const consultantList: ILeadModalConsultant[] = [
    {
        image: {s72: wiktoria_72, s144: wiktoria_144, s216: wiktoria_216},
        gender: "female",
        fullName: "Wiktoria Mościszko"
    },
    {
        image: {s72: roza_72, s144: roza_144, s216: roza_216},
        gender: "female",
        fullName: "Róża Parzyszek"
    },
    {
        image: {s72: justyna_72, s144: justyna_144, s216: justyna_216},
        gender: "female",
        fullName: "Justyna Budrewicz"
    },
    {
        image: {s72: daniel_72, s144: daniel_144, s216: daniel_216},
        gender: "male",
        fullName: "Daniel Reinert"
    }
];

export function getRandomConsultant() {
    const randomIndex = Math.floor(Math.random() * consultantList.length);
    return consultantList[randomIndex];
}
